const ONES = [
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "ten",
  "eleven",
  "twelve",
  "thirteen",
  "fourteen",
  "fifteen",
  "sixteen",
  "seventeen",
  "eighteen",
  "nineteen",
] as const;

const TENS = [
  "",
  "",
  "twenty",
  "thirty",
  "forty",
  "fifty",
  "sixty",
  "seventy",
  "eighty",
  "ninety",
] as const;

const CURRENCY_NAMES: Record<string, { major: string; minor: string }> = {
  INR: { major: "rupees", minor: "paise" },
  AED: { major: "dirhams", minor: "fils" },
  USD: { major: "dollars", minor: "cents" },
};

const underThousandToWords = (value: number): string => {
  if (value < 20) return ONES[value];
  if (value < 100) {
    return `${TENS[Math.floor(value / 10)]}${value % 10 ? ` ${ONES[value % 10]}` : ""}`;
  }

  const remainder = value % 100;
  return `${ONES[Math.floor(value / 100)]} hundred${
    remainder ? ` ${underThousandToWords(remainder)}` : ""
  }`;
};

const integerToWords = (value: number): string => {
  if (value === 0) return "zero";

  if (value < 1000) {
    return underThousandToWords(value);
  }

  if (value < 100000) {
    const thousands = Math.floor(value / 1000);
    const remainder = value % 1000;

    return `${underThousandToWords(thousands)} thousand${
      remainder ? ` ${integerToWords(remainder)}` : ""
    }`;
  }

  if (value < 10000000) {
    const lakhs = Math.floor(value / 100000);
    const remainder = value % 100000;

    return `${underThousandToWords(lakhs)} lakh${remainder ? ` ${integerToWords(remainder)}` : ""}`;
  }

  const crores = Math.floor(value / 10000000);
  const remainder = value % 10000000;

  return `${integerToWords(crores)} crore${remainder ? ` ${integerToWords(remainder)}` : ""}`;
};

export const amountToWords = (value: string, currencyCode: string): string => {
  const normalizedValue = value.replace(/,/g, "").trim();
  if (!normalizedValue) return "";

  const numericValue = Number(normalizedValue);
  if (!Number.isFinite(numericValue) || numericValue < 0) return "";

  const [wholePart, decimalPart = ""] = numericValue.toFixed(2).split(".");
  const { major, minor } = CURRENCY_NAMES[currencyCode] ?? {
    major: currencyCode.toLowerCase(),
    minor: "minor units",
  };
  const whole = `${integerToWords(Number(wholePart))} ${major}`;
  const decimal = Number(decimalPart) ? ` and ${integerToWords(Number(decimalPart))} ${minor}` : "";

  return `${whole}${decimal} only`;
};
